export enum LogType {
  DATA_COLLECTOR_LOG = 'DATA_COLLECTOR_LOG',
  DIAGNOSTICS_LOG = 'DIAGNOSTICS_LOG',
  SECURITY_LOG = 'SECURITY_LOG'
}

export enum LogResponseStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELED_PREVIOUS = 'CANCELED_PREVIOUS',
  REJECTED = 'REJECTED',
  NONE = 'NONE'
}

export enum LogUploadStatus {
  BAD_MESSAGE = 'BAD_MESSAGE',
  IDLE = 'IDLE',
  NOT_SUPPORTED_OPERATION = 'NOT_SUPPORTED_OPERATION',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  UPLOADED = 'UPLOADED',
  UPLOAD_FAILURE = 'UPLOAD_FAILURE',
  UPLOADING = 'UPLOADING',
  ACCEPTED_CANCELED = 'ACCEPTED_CANCELED',
  NONE = 'NONE'
}

export enum LogStorageLocation {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export interface LogRequest {
  id: string;
  createdAt: Date;
  type: LogType;
  responseReceivedAt?: Date;
  responseStatus: LogResponseStatus[];
  fileName?: string;
  errorCode?: string; // OCPP 2.x only
  uploadStatus?: LogUploadStatus;
  uploadStatusModifiedAt?: Date;
  storageLocation: LogStorageLocation
}
